module.exports = __webpack_public_path__ + "static/img/business19.98c7b2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business19.jpg
// module id = fc9t
// module chunks = 9